<template>
    <div class="spareparts">
        <b-modal no-close-on-backdrop title="Document Preview" class="modal-success" v-model="docDlg" ok-variant="success" :ok-only="true" @ok="docDlg = false" ok-title="Close" size="lg">
            <div v-if="pdfpages>1">
                <button @click="pdfpage = pdfpage - 1" :disabled="pdfpage == 1">&#9111;</button>
                {{ pdfpage }} / {{ pdfpages }}
                <button @click="pdfpage = pdfpage + 1" :disabled="pdfpage == pdfpages">&#9112;</button>
            </div>
            <pdf :src="pdfsrc" :page="pdfpage" style="display: inline-block; width: 100%" @num-pages="pdfpages = $event" @page-loaded="pdfpage = $event">
            </pdf>
        </b-modal>
        <b-modal no-close-on-backdrop title="Client Debt details" class="modal-success" v-model="debtDlg" ok-variant="success" :ok-only="true" @ok="debtDlg = false" ok-title="Close" size="lg">
            <b-container fluid>
                <table border="1" class="debtdlg">
                    <thead>
                        <tr>
                            <th>Invoice</th>
                            <th>Expiration</th>
                            <th>Total</th>
                            <th>Debt</th>
                            <th>days</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(c, i) in debtDetail" :key="i">
                            <td>{{ c.invoice_n }}</td>
                            <td>{{ new Date(c.expiration_date).toLocaleDateString() }}</td>
                            <td class="d">{{ formatter(c.invoice_amt_EURO) }}</td>
                            <td class="d">{{ formatter(c.balance_amt_EURO) }}</td>
                            <td class="d">{{ c.diff }}</td>
                        </tr>
                    </tbody>
                </table>
                <vue-excel-xlsx :data="data" :columns="columns" :file-name="'filename'" :file-type="'xlsx'" :sheet-name="'sheetname'" class="btn btn-info">
                    Download <v-icon name="regular/file-excel" />
                </vue-excel-xlsx>
            </b-container>
        </b-modal>
        <b-tabs content-class="mt-3" @input="tabChanged">
            <b-tab title="Orders" active>
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <AgGridVue style="
                                    width: calc(100% - 20px);
                                    height: calc(100vh - 130px);
                                " class="ag-theme-alpine" rowModelType="serverSide" :debug="true" :pagination="true" :paginationPageSize="18" :cacheBlockSize="180" :serverSideDatasource="serverSideDatasource"
                                :serverSideStoreType="'partial'" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :suppressColumnVirtualisation="false" @first-data-rendered="onFirstDataRendered"
                                @grid-ready="onGridReady" @store-updated="StoreUpdated">
                            </AgGridVue>
                        </b-col>
                    </b-row>
                </b-container>
            </b-tab>
            <b-tab :title="isClient ? 'Cart' : 'RFQ'">
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <RFQ ref="rfq"/>
                        </b-col>
                    </b-row>
                </b-container>
            </b-tab>
            <b-tab title="Full search by part" >
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <BillOfMaterials />
                        </b-col>
                    </b-row>
                </b-container>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import pdf from "vue-pdf";
import RFQ from "./RFQ.vue";
import BillOfMaterials from "./BillOfMaterials.vue";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
    name: "Spareparts",
    components: {
        AgGridVue,
        pdf,
        RFQ,
        BillOfMaterials,
    },
    data() {
        // console.log("AMM???",this.isAmministrativo(),this.$store.getters.amministrativo)
        return {
            currTab: 0,
            columns: [{ label: "Invoice", field: "invoice", }, { label: "Expiration", field: "expiration" }, { label: "Total", field: "total", }, { label: "Debt", field: "debt", }, { label: "days", field: "days", }],
            debtDetail: [],
            debtDlg: false,
            docDlg: false,
            pdfsrc: undefined,
            firstTime: true,
            pdfpage: 1,
            pdfpages: 1,
            filter: "",
            fields: [
                { key: "spare_code", class: "font-weight-bold", },
                { key: "text" },
                { key: "ddt" },
                { key: "shipdate", formatter: "dateFormatter" },
                { key: "invoice" },
                { key: "invoicedate", formatter: "dateFormatter" },
            ],
            spares: [],
            defaultColDef: {
                sortable: true,
                filter: true,
                filterParams: { buttons: ["reset", "apply"] },
                resizable: true,
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [
                {
                    hide: true,
                    field: "ddtk",
                },
                {
                    hide: true,
                    field: "invoicek",
                },
                {
                    hide: !this.isAmministrativo(),
                    headerName: "P.I.",
                    field: "client_code",
                    filter: "agTextColumnFilter",
                    // valueFormatter: this.clientFormatter,
                    cellRenderer: this.cellRenderer,
                    cellStyle: { cursor: 'pointer' },
                    onCellClicked: this.onClientCellClicked,
                },
                {
                    headerName: "Client",
                    field: "client_name",
                    filter: "agTextColumnFilter",
                    // valueFormatter: this.clientFormatter,
                    // cellRenderer: this.cellRenderer,
                    cellStyle: this.isAmministrativo() ? { cursor: 'pointer' } : {},
                    onCellClicked: this.isAmministrativo() ? this.onClientCellClicked : null,
                },
                // {
                // 	headerName: "Machine",
                // 	field: "ITMREF_0",
                // 	filter: "agTextColumnFilter",
                // },
                {
                    headerName: "Date",
                    field: "invoicedate",
                    filter: "agDateColumnFilter",
                    valueFormatter: this.dateFormatter,
                },
                {
                    headerName: "Area",
                    field: "AREA_0",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Country",
                    field: "COUNTRY_0",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Spare Code",
                    field: "spare_code",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Spare Descr.",
                    cellClass: "ag-left-aligned-cell",
                    maxWidth: 450,
                    type: "leftAligned",
                    field: "text",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "QTY",
                    cellClass: "ag-left-aligned-cell",
                    maxWidth: 450,
                    type: "leftAligned",
                    field: "qta",
                    filter: "agNumberColumnFilter",
                },
                {
                    headerName: "Order",
                    field: "rif_ord_cli",
                    filter: "agTextColumnFilter",
                    type: "leftAligned",
                },
                {
                    headerName: "DDT",
                    field: "ddt",
                    filter: "agTextColumnFilter",
                    cellStyle: { cursor: 'pointer' },
                    onCellClicked: this.onDDTCellClicked,
                },
                {
                    headerName: "Invoice",
                    field: "invoice",
                    filter: "agTextColumnFilter",
                    cellStyle: { cursor: 'pointer' },
                    onCellClicked: this.onINVCellClicked,
                },
                {
                    headerName: "Tracking Date",
                    valueFormatter: this.dateFormatter2,
                    field: "YDBOLLETTINO_0",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Tracking Number",
                    field: "YNBOLLETTINO_0",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Carrier",
                    field: "BPTNAM_0",
                    filter: "agTextColumnFilter",
                },
            ],
            serverSideDatasource: {
                getRows: async (params) => {
                    this.clients = false;
                    console.log("getRows", params);
                    var response = await API.getSparesServerSold(params);
                    // console.log("RESPONSE", response);
                    let mask = this.$store.getters.mask
                    response.rows = response.rows.map((d) => ({
                        client_code: d.client_code,
                        client_name: mask ? "*****" : (d.client_name != ' ' ? d.client_name : d.client_code),
                        ITMREF_0: d.ITMREF_0,
                        spare_code: d.spare_code,
                        text: d.text,
                        invoicedate: new Date(d.invoicedate),
                        AREA_0: d.AREA_0,
                        COUNTRY_0: d.COUNTRY_0,
                        invoice: d.invoice,
                        ddt: d.ddt,
                        invoicek: d.invoicek,
                        ddtk: d.ddtk,
                        qta: d.qta,
                        rif_ord_cli: d.rif_ord_cli,
                        YDBOLLETTINO_0: d.YNBOLLETTINO_0 > 0 ? d.YDBOLLETTINO_0 : '',
                        YNBOLLETTINO_0: d.YNBOLLETTINO_0,
                        BPTNAM_0: d.BPTNAM_0,
                        amount: d.amount,
                    }));
                    if (response.success) {
                        params.successCallback(response.rows, response.lastRow);
                    } else {
                        params.fail();
                    }
                    if(this.firstTime){
                        this.firstTime = false
                        this.sortByDateDesc()
                    }
                },
            },
        };
    },
    async mounted() {
        // let spares = await API.getSpares();
        // this.spares = spares.map((t) => ({
        // 	...t,
        // 	shipdate: new Date(t.shipdate),
        // 	invoicedate: new Date(t.invoicedate),
        // }));
    },
    computed: {
        isClient() {
            return !this.$store.getters.marsilli
        },
        data() {
            let ret = []
            for (let c of this.debtDetail) {
                let d = {}
                d.invoice = c.invoice_n
                d.expiration = new Date(c.expiration_date).toLocaleDateString()
                d.total = c.invoice_amt_EURO
                d.debt = c.balance_amt_EURO
                d.days = c.diff
                ret.push(d)
            }
            return ret
        }
    },
    methods: {
        tabChanged(index) {
            this.currTab = index;
            if(index == 1){
                setTimeout(() => {
                    this.$refs.rfq.onFirstDataRendered()
                },500)
            }
        },
        sortByDateDesc(){
            console.log("SORT BY DATE DESC")
            this.columnApi.applyColumnState({
                state: [{ colId: "invoicedate", sort: "desc" }],
                defaultState: { sort: null },
            });
        },
        isAmministrativo() {
            return this.$store.getters.amministrativo
        },
        formatter(value) {
            const fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', })
            return fmt.format(value)
        },
        async onClientCellClicked(value) {
            let data = await API.getDebt(value.data.client_code)
            // console.log("VALUE",value.data.client_code,data)
            this.debtDetail = data
            this.debtDlg = true
        },
        async onINVCellClicked(value) {
            console.log("VALUE", value)
            let pdf = await API.getDDT(value.data.invoicek)
            console.log("ID", pdf)
            if (pdf) {
                this.openPDF(pdf)
            }
        },
        async onDDTCellClicked(value) {
            console.log("VALUE", value)
            let pdf = await API.getDDT(value.data.ddtk)
            console.log("ID", pdf)
            if (pdf) {
                this.openPDF(pdf)
            }
        },
        async openPDF(pdf) {
            // var loadingTask = pdf.createLoadingTask(
            // 	API.getDocCall(this.m.codice, zfile, doc.id_file)
            // ); //"Gefran_1600-1800_d.pdf");
            // loadingTask.promise.then((pdf) => {
            // 	this.pdfpages = pdf.numPages;
            // 	// se cambio in fretta il viewer si incatorcia
            // 	setTimeout(() => {
            // 		this.enabled = true;
            // 	}, 2000);
            // });
            console.log("PDF", pdf)
            const blob = new Blob([pdf]);
            const objectUrl = URL.createObjectURL(blob, { type: 'application/pdf' });
            this.pdfsrc = objectUrl
            this.docDlg = true
        },
        cellRenderer(value) {
            // console.log("DATA:",value)
            if (value.data.amount > 0)
                return `<b><span style="color: red;">&#11044;</span></b>`
            else
                return `<b><span style="color: green;">&#11044;</span></b>`
        },
        clientFormatter(value) {
            // console.log("DATA:",value)
            if (value.data.amount > 0)
                return `(*) ${value.value}`
            else
                return `${value.value}`
        },
        dateFormatter(value) {
            // console.log("DATA:",value.value.getTime())
            if (value.value.getTime() == 0)
                return " - "
            else
                return value.value.toLocaleDateString();
        },
        dateFormatter2(value) {
            return value.value ? value.value.split("T")[0] : ""
        },
        onGridReady(params) {
            // console.log("onGridReady", params);
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
        },
        // eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            // console.log("onFirstDataRendered", event);
            this.columnApi.autoSizeAllColumns();
        },
        // eslint-disable-next-line no-unused-vars
        StoreUpdated(event) {
            // console.log("StoreUpdated", event);
            setTimeout(() => {
                this.columnApi.autoSizeAllColumns();
            }, 500)
        },
    },
};
</script>
<style>
table.debtdlg {
    width: 100%;
}

table.debtdlg td {
    text-align: center;
    padding: 2px;
}

table.debtdlg td.d {
    text-align: right;
    padding: 2px;
}

table.debtdlg th {
    text-align: center;
    padding: 2px;
}

div.spareparts td,
div.spareparts th {
    text-align: left;
}

.ag-left-aligned-cell {
    text-align: left;
}
</style>
